export default "__VITE_ASSET__D5U0XjoN__"